import { axiosClient } from '../../../shared/api';

export const listPayments = async (query = '') => {
  const response = await axiosClient.get(`/payments${query}`);
  return response.data;
};

export const createPayment = async (paymentData) => {
  const response = await axiosClient.post('/payments', paymentData);
  return response.data;
};
